module.exports = __webpack_public_path__ + "img/logo.003189a9.webp";